import React, { useEffect, useState } from 'react';
import API from '../Api';
import { Link } from 'react-router-dom';
import SubPageHeader from '../../components/common/SubPageHeader';

const MotivationalLecture = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchLectureData = async () => {
      try {
        const res = await API.get('get-content/Lectures/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading lecture data:", err);
      }
    };
    fetchLectureData();
  }, []);
  const defaultTopics = [
    "Happiness Index", "Happiness Index for Companies", "Mudras- The divine Pharmacy",
    "Unleash your peak potential : Students", "Unleash your peak potential: Women", "Unleash your peak potential: Men"
  ];
  const topics = [1, 2, 3, 4, 5, 6, 7, 8].map(i => data[`topic_${i}`]).filter(t => t);
  const displayTopics = topics.length > 0 ? topics : defaultTopics;

  return (
    <div className="min-h-screen bg-white">
      {/* Updated Header without italic title */}
      <SubPageHeader title="MOTIVATIONAL LECTURE" />

      <div className="py-10 md:py-20 px-4 md:px-6">
        {/* Main Blue Bordered Container */}
        <div className="max-w-4xl mx-auto border-4 md:border-[12px] border-[#003366] rounded-2xl shadow-2xl  md:rounded-[40px] p-5 sm:p-8 md:p-16">
          
          <div className="space-y-5 md:space-y-8 text-[#1a1a1a] text-[15px] md:text-[17px] leading-7 md:leading-relaxed font-medium">
            <p className="text-lg  sm:text-xl md:text-2xl text-[#003366] font-bold leading-relaxed">
              The Global School of Happiness works with a mission to spread happiness to every soul on this planet.
            </p>

            <p className="text-base md:text-lg leading-relaxed">
              We conduct motivational lectures in this regard on the different topics viz;
            </p>

           {/* List of Topics */}
            <ul className="space-y-3 md:space-y-4 pl-0 md:pl-6">
              {displayTopics.map((topic, index) => (
                <li key={index} className="flex items-start text-base sm:text-lg md:text-xl leading-relaxed">
                  <span className="mr-3 md:mr-4 text-[#003366] font-bold shrink-0">{index + 1})</span>
                  <span className="uppercase tracking-tight">{topic}</span>
                </li>
              ))}
            </ul>

            <p className="text-base md:text-lg pt-6 border-t border-gray-100 leading-relaxed">
              Send a query or contact for further details & finalization of dates.
            </p>
          </div>

          {/* Call to Action Section */}
          <div className="mt-12 text-center space-y-6">
            <p className="text-[#003366] font-bold text-base sm:text-lg md:text-xl  uppercase tracking-wide text-center leading-relaxed">
              JOIN THE HAPPINESS FAMILY!
            </p>
            <div className="pt-4">
              <Link 
                to="/TGSH/login" 
                className="
                inline-block
                w-full
                sm:w-auto
                bg-[#003366]
                text-white
                px-8
                md:px-10
                py-3
                rounded-full
                font-bold
                uppercase
                tracking-wide
                hover:bg-[#005f8d]
                transition-all
                shadow-lg
                active:scale-95
                "
              >
                Login To Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotivationalLecture;